/* eslint-disable */
import React from 'react'; 
import { loadAnalytics } from "./withTracker";
import { hashHistory } from 'react-router';
import axios from 'axios'; 
const Loading = require('./loading');
const config = require('./config');
const lang = require('./lang');
const APIURL = config.path.apiUrl;
const APPID = config.ids.appId;
import cookie from 'react-cookie';
import DocumentMeta from 'react-document-meta';
var helper = require("./Helper.js");

/* Load meta tags */
const meta = {
  title: lang.activation_meta_title,
  description: lang.activation_meta_title,
  meta: {
	name: {
	  keywords: lang.activation_meta_title
	}
  }
};



class Activation extends React.Component {
	

	componentWillMount () { 
	
	   /* add class */
	     helper.addBodyClass();
	
	}
	 /* Account activation */
	   componentDidMount () { 
 loadAnalytics();
	     var qs = require('qs');
	   	var activationId = this.props.params.activationId;
		
	 /* for account activation - start */	
	 if( typeof activationId !== 'undefined' && activationId !=="")
	  {	
	  // return false;
		var postObject = {
				   "app_id": APPID,
				   "key" : activationId,
				   }; 
		axios.post(APIURL+"customer/activation", qs.stringify(postObject)).then(response => {
		
		/* Success response */
		if(response.data.status==="ok"){ 
			 var errorMsg = response.data.message;
			 helper.showInfo( errorMsg);
		     hashHistory.push("/sign-in");
		}
		
			/* Success response */
		if(response.data.status==="error"){ 
		
		 var errorMsg = response.data.message;
		  helper.showInfo( errorMsg);
		 hashHistory.push("/sign-in");
		}
		/* error reponse */
		
		}); 
	}
	 /* for account activation - end  */		
		
	   }
	   
	     render() {
              return ( <div> 
			  		<DocumentMeta  {...meta} />
						{/*<Loading/> */}
							<div className="chk_popup act_loder" id="PayProcess" style={{position: 'unset'}} > 
		<div className="white-outer center-block process_order">
		  <div className="row ">
			<div className="col-xs-12 padd2">
			  <h4>{lang.activation_meta_title}</h4>
			  <div className="clock_part">
			<img src="/img/spinner.gif" alt="" />
				<br/> 
			  </div>
			</div>
		  </div>
		</div>
		
		
</div>
			  </div>)
		 }
	 
 }
 export default Activation;



// WEBPACK FOOTER //
// ./src/Activation.js